<template>
    <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
        title="Item Bem Permanente > Documento do Item Bem Permanente">
        <DocumentoIBPList :id="id"></DocumentoIBPList>
    </b-modal>
</template>

<script>

import DocumentoIBPList from '@/modules/patrimonio/documentoibp/DocumentoIBPList.vue';

export default {
    name: "ModalDocumentoIBP",
    components: {
        DocumentoIBPList,
        
    },
    props: {
        id: Number,
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>